"use client";
import { useNavigate } from "react-router-dom";
import "./Footer.css";

// Simple icon components to replace Lucide icons
const FacebookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const InstagramIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452H17.2v-5.569c0-1.327-.472-2.233-1.654-2.233-.902 0-1.438.608-1.674 1.197-.086.21-.108.5-.108.792v5.813h-3.248s.043-9.431 0-10.407h3.248v1.475c.431-.665 1.203-1.611 2.928-1.611 2.137 0 3.738 1.395 3.738 4.396v6.147zM5.337 7.433c-1.106 0-1.83.727-1.83 1.682 0 .939.702 1.683 1.786 1.683h.022c1.128 0 1.83-.744 1.83-1.683-.022-.955-.702-1.682-1.808-1.682zM6.874 20.452H3.79V10.045h3.084v10.407zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z" />
  </svg>
);

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (route) => {
    navigate(route);
  };

  const handleSocialClick = (platform) => {
    const socialUrls = {
      Facebook: "#", // disabled for now
      Instagram: "https://instagram.com/shipmentsolutions_llc/",
      LinkedIn: "https://www.linkedin.com/company/shipmentsolutionsllc/", // update this with actual LinkedIn URL
    };

    if (socialUrls[platform]) {
      window.open(socialUrls[platform], "_blank");
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo">
          <img
            src="/assets/newlogowhite.png"
            alt="SS Logo"
            className="footer-logo-img"
          />
        </div>

        <nav className="footer-nav">
          <div className="footer-nav-list">
            <button className="footer-nav-button" onClick={() => handleNavigation("/")}>
              Home
            </button>
            <span className="footer-separator">|</span>
            <button className="footer-nav-button" onClick={() => handleNavigation("/aboutus")}>
              About us
            </button>
            <span className="footer-separator">|</span>
            <button className="footer-nav-button" onClick={() => handleNavigation("/contactus")}>
              Contact
            </button>
            <span className="footer-separator">|</span>
            <button className="footer-nav-button" onClick={() => handleNavigation("/inventory")}>
              Auction
            </button>
            <span className="footer-separator">|</span>
            <button className="footer-nav-button" onClick={() => handleNavigation("/#")}>
              Inquiry
            </button>
          </div>
        </nav>

        <div className="footer-contact">
          <div className="footer-contact-row">
            <div className="footer-contact-item">
              <span className="footer-contact-icon">📧</span>
              <span>info@shipmentsolutionsllc.com</span>
            </div>
            <div className="footer-contact-item">
              <span className="footer-contact-icon">📞</span>
              <span>+1 (346) 464-9730</span>
            </div>
          </div>
          <div className="footer-address">
            <span className="footer-contact-icon">📍</span>
            <span>Katy, Texas, USA</span>
          </div>
          <div className="footer-address">
            <span className="footer-contact-icon">📍</span>
            <span>127-1081, Nishinoyacho, Naka-ku, Yokohama, Japan</span>
          </div>
        </div>

        <div className="footer-social">
          <button className="footer-social-button" onClick={() => handleSocialClick("Facebook")} aria-label="Facebook">
            <FacebookIcon />
          </button>
          <button className="footer-social-button" onClick={() => handleSocialClick("Instagram")} aria-label="Instagram">
            <InstagramIcon />
          </button>
          <button className="footer-social-button" onClick={() => handleSocialClick("LinkedIn")} aria-label="LinkedIn">
            <LinkedInIcon />
          </button>
        </div>

        <div className="footer-copyright">
          ©2025 ShipmentSolutionsLLC. All rights reserved. |
          <button className="footer-copyright-button" onClick={() => handleNavigation("#")}>
            Privacy
          </button>{" "}
          |
          <button className="footer-copyright-button" onClick={() => handleNavigation("#")}>
            Terms
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
